import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import wordmark from '@/assets/icons/logo_felton.svg';
import railMark from './assets/rail-mark.svg';

interface SidebarBrandProps {
  readonly collapsed: boolean;
}

/**
 * The wordmark when the sidebar is open, the mark alone in the rail.
 *
 * The rail mark is the wordmark's "o" on the lively-lime plate, exported from
 * the rail frame (47:3655). The plate is the brand colour in both themes, so
 * unlike the wordmark it is not inverted in dark mode.
 */
export const SidebarBrand: React.FC<SidebarBrandProps> = ({ collapsed }) => {
  const { t } = useTranslation();

  return (
    <Link
      to="/v11/feed"
      className={`flex items-center justify-center ${collapsed ? 'pb-[17px]' : 'pb-5 pt-[10px]'}`}
      aria-label={t('app.v11.nav.logoAlt')}
    >
      <img
        src={collapsed ? railMark : wordmark}
        alt={t('app.v11.nav.logoAlt')}
        className={
          collapsed
            ? 'h-10 w-10 object-contain'
            : 'h-auto w-[196px] object-contain dark:brightness-0 dark:invert'
        }
      />
    </Link>
  );
};
